const HOME_SOURCE_LOCATION = 'page:home'

const normalizePageSegment = segment =>
  segment
    .replace(/^_+/, '')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/_/g, '-')
    .replace(/[^a-zA-Z0-9-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase()

const dedupeAdjacentSegments = segments =>
  segments.filter((segment, index) => index === 0 || segment !== segments[index - 1])

const getBuyerIntentPageSourceLocation = pathname => {
  if (!pathname || pathname === '/') {
    return HOME_SOURCE_LOCATION
  }

  const normalizedSegments = pathname
    .split('/')
    .filter(Boolean)
    .map(normalizePageSegment)
    .filter(Boolean)
    .filter((segment, index, segments) => !(segment === 'index' && index === segments.length - 1))

  const sourceSegments = dedupeAdjacentSegments(normalizedSegments)

  if (sourceSegments.length === 0) {
    return HOME_SOURCE_LOCATION
  }

  return `page:${sourceSegments.join('-')}`
}

export { HOME_SOURCE_LOCATION, getBuyerIntentPageSourceLocation }
